import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Hammer & Anvil Forge Icon
const ForgeIcon = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M6 28H34V32C34 33.1 33.1 34 32 34H8C6.9 34 6 33.1 6 32V28Z" fill="currentColor"/>
    <path d="M4 24H36V28H4V24Z" fill="currentColor"/>
    <path d="M10 20H30V24H10V20Z" fill="currentColor"/>
    <path d="M20 6L24 10L20 14L16 10L20 6Z" fill="#D4AF37"/>
    <path d="M18 12L22 16V20H18V16L18 12Z" fill="#D4AF37"/>
    <circle cx="12" cy="18" r="1" fill="#D4AF37"/>
    <circle cx="28" cy="16" r="1" fill="#D4AF37"/>
  </svg>
);

export default function AuthCallback({ onLogin }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error("No session_id found in URL");
          navigate("/login");
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/google-session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);

        // Login and navigate
        onLogin(response.data);
        navigate("/dashboard", { state: { user: response.data } });
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/login");
      }
    };

    processAuth();
  }, [navigate, onLogin]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="flex flex-col items-center gap-6">
        <div className="w-16 h-16 bg-[#0A0A0A]/80 backdrop-blur-sm border border-white/[0.08] flex items-center justify-center animate-pulse text-white">
          <ForgeIcon className="w-10 h-10" />
        </div>
        <div className="w-12 h-12 border-4 border-gold border-t-transparent rounded-full animate-spin" />
        <p className="text-white/70 font-body">Authenticating...</p>
      </div>
    </div>
  );
}
